import React, { Component } from "react";
import Item, { LargeItem } from "../components/items";
import firebase from "../config/firebaseInit";
import snack from "../assets/images/snack.png";
import hotel from "../assets/images/hotel.png";
import divers from "../assets/images/divert.png";
import Lieu, { Reservation, Position, Service, UserSend } from "../model/lieux";
import { shuffle } from "../config/utils";
import geolib from "geolib";
import HozItem from "../components/horiz_item";
import Icon from "../assets/images/bootstrap-solid.svg";
import { DeviceUUID } from "device-uuid/lib/device-uuid";
import "../assets/css/placeholder.css";

function calcCrow(lat1, lon1, lat2, lon2) {
  let R = 6371; // km
  let dLat = toRad(lat2 - lat1);
  let dLon = toRad(lon2 - lon1);
  lat1 = toRad(lat1);
  lat2 = toRad(lat2);

  let a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2);
  let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  let d = R * c;
  return d;
}

function toRad(Value) {
  return Value * Math.PI / 180;
}

let db = firebase.firestore();


/*


admin.initializeApp(config);


let token = "";
messaging.getToken().then((currentToken) => {
  if (currentToken) {
    token = currentToken;
    console.log(currentToken);
  } else {
    console.log('No Instance ID token available. Request permission to generate one.');
  }
}).catch((err) => {
  console.log('An error occurred while retrieving token. ', err);
});




let topic = "niochi-message";

admin.messaging().subscribeToTopic([token], topic)
  .then(function (response) {

    console.log('Successfully subscribed to topic:', response);
  })
  .catch(function (error) {
    console.log('Error subscribing to topic:', error);
  });


  var message = {
    notification: {
      title: '$GOOG up 1.43% on the day',
      body: '$GOOG gained 11.80 points to close at 835.67, up 1.43% on the day.'
    },
  };

admin.messaging().send(message)
    .then((response) => {
      console.log('Successfully sent message:', response);
    })
    .catch((error) => {
      console.log('Error sending message:', error);
    });*/
//let messaging = firebase.messaging();

/* if ('serviceWorker' in navigator) {
  navigator.serviceWorker.ready.then(registration => {
     console.log("=================================================::::::::::::")
 
    // messaging.usePublicVapidKey("BF72UWOEwktwUHr8qIvV_K4cFcnQIckb6QC6MzjRRSRHty2lZJWSQahWkZv9kwGerrP03fgbLb_CiZSc5n2P1uM");
     //messaging.useServiceWorker(registration);
     Notification.requestPermission().then((permission) => {
       messaging.getToken().then((currentToken) => {
         if (currentToken) {
           console.log(currentToken);
 
           let uid = new DeviceUUID().get();
 
           db.collection("token").doc(uid).set({
             token: currentToken,
             deviceId: uid
           });
 
         } else {
           console.log('No Instance ID token available. Request permission to generate one.');
         }
       }).catch((err) => {
         console.log('An error occurred while retrieving token. ', err);
       });
 
     }).catch(() => {
       console.log("error");
     })
   });
 }
 
 messaging.onMessage((payload) => {
   console.log('Message received. ', payload);
   navigator.serviceWorker.ready.then(registration => {
     registration.showNotification("TEST");
     console.log("SHOW");
   });
 });*/
class Home extends Component {
  constructor(props) {
    super(props);
    this.state = { proche: [], choix: [], favorie: [], query: "", search: false, searchResult: [] };
    this.onType = this.onType.bind(this);
    this.onSubmit = this.onSubmit.bind(this);

  }
  componentDidMount() {
    let lat = null;
    let long = null;
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        lat = position.coords.latitude;
        long = position.coords.longitude;
      }, function () { });
    }
    db.collection('lieux').get()
      .then((snapshot) => {
        let customArray = [];
        snapshot.forEach((doc) => {

          let lieu = new Lieu(doc.data().pathToImage, doc.data().designation, calcCrow(lat, long, doc.data().position.latitude, doc.data().position.longitude).toFixed(1), doc.data().adresse, doc.data().description
            , doc.data().heureFermeture, doc.data().heureOuverture, new Position(doc.data().position.latitude, doc.data().position.longitude)
            , new Reservation(doc.data().numero, doc.data().state), new Service([], []),
            doc.data().type, doc.data().telephone, "", "", "", doc.data().ville, doc.data().selectedArrondisement,
            new UserSend(doc.data().sendBy.pathToImage, doc.data().sendBy.name), doc.data().categorie, doc.data().anonymous);
          customArray.push(lieu);
        });

        customArray.sort((a, b) => {
          console.log(a)
          if (lat != null && long != null) {
            let position1 = geolib.getDistance(
              { latitude: lat, longitude: long },
              { latitude: a.position.latitude, longitude: a.position.longitude })

            let position2 =
              geolib.getDistance(
                { latitude: lat, longitude: long },
                { latitude: b.position.latitude, longitude: b.position.longitude })
            return position1 - position2;
          }
        });

        this.setState({ proche: customArray.slice(0, 6) })
      })
      .catch((err) => {
        console.log('Error getting documents', err);
      });

    db.collection("lieux").orderBy("like").limit(3).get().then((snapshot) => {

      let customArray = [];
      snapshot.forEach((doc) => {

        let lieu = new Lieu(doc.data().pathToImage, doc.data().designation, calcCrow(lat, long, doc.data().position.latitude, doc.data().position.longitude).toFixed(1), doc.data().adresse, doc.data().description
          , doc.data().heureFermeture, doc.data().heureOuverture, new Position(doc.data().position.latitude, doc.data().position.longitude)
          , new Reservation(doc.data().numero, doc.data().state), new Service([], []),
          doc.data().type, doc.data().telephone, "", "", "", doc.data().ville, doc.data().selectedArrondisement,
          new UserSend(doc.data().sendBy.pathToImage, doc.sendBy.data().name)
          , doc.data().categorie, doc.data().anonymous);
        customArray.push(lieu);
      });

      this.setState({ favorie: customArray });
    })

    db.collection("lieux").get().then((snapshot) => {
      let randomArray = shuffle(snapshot.docs).splice(0, 3);
      let customArray = [];
      randomArray.forEach((doc) => {
        let lieu = new Lieu(doc.data().pathToImage, doc.data().designation
          , calcCrow(lat, long, doc.data().position.latitude, doc.data().position.longitude).toFixed(1), doc.data().adresse, doc.data().description
          , doc.data().heureFermeture, doc.data().heureOuverture, new Position(doc.data().position.latitude, doc.data().position.longitude)
          , new Reservation(doc.data().numero, doc.data().state), new Service([], []),
          doc.data().type, doc.data().telephone, "", "", "", doc.data().ville, doc.data().selectedArrondisement
          , new UserSend(doc.data().sendBy.pathToImage, doc.data().sendBy.name)
          , doc.data().categorie, doc.data().anonymous);
        customArray.push(lieu);
      });
      this.setState({ choix: customArray });
    });


  }

  onType(e) {
    this.setState({ query: e.target.value });
  }
  onSubmit(e) {
    e.preventDefault();
    if (this.state.query != "") {
      let db = firebase.firestore();
      let lat = null;
      let long = null;
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((position) => {
          lat = position.coords.latitude;
          long = position.coords.longitude;
        }, function () { });
      }
      let customArray = [];
      db.collection("lieux").get().then((snapshot) => {
        snapshot.forEach((doc) => {
          if (doc.data().designation.toLowerCase().includes(this.state.query.toLowerCase()) || doc.data().adresse.toLowerCase().includes(this.state.query.toLowerCase())
            || doc.data().description.toLowerCase().includes(this.state.query.toLowerCase())
          ) {
            console.log(this.state.query + "............;" + doc.id);

            let lieu = new Lieu(doc.data().pathToImage, doc.data().designation
              , calcCrow(lat, long, doc.data().position.latitude, doc.data().position.longitude).toFixed(1)
              , doc.data().adresse, doc.data().description
              , doc.data().heureFermeture, doc.data().heureOuverture, new Position(doc.data().position.latitude, doc.data().position.longitude)
              , new Reservation(doc.data().numero, doc.data().state), new Service([], []),
              doc.data().type, doc.data().telephone);

            lieu.addUid(doc.id);
            customArray.push(lieu);
          }
        });

        this.setState({
          search: true,
          searchResult: customArray
        });
      });
    }

  }
  render() {
    return (
      <React.Fragment>

        <section className="jumbotron text-center mt-45">
          <div className="container">
            <img className="mb-4" src={Icon} alt="" width="50" height="50" />
            <p className="lead-mod">Rechercher un hôtel, un motel, un restaurant ou un bar</p>
            <div className="mt-3">
              <div className="input-group">
                <input type="text" name="query" onChange={this.onType} value={this.state.query} className="form-control" id="username" placeholder="Rechercher un hôtel, un motel, un restaurant ou un bar" required />

                <button href="results.html" onClick={this.onSubmit} className="text-white link-decobtn btn btn-md btn-primary btn-block mt-3" type="submit">
                  Rechercher
                     </button>
              </div>
            </div>
          </div>
        </section>
        {
          this.state.search ? (


            <div className="album py-5 bg-light d-sm-block">
              <div className="container">
                {this.state.searchResult.map((result) => <HozItem article={result} />)}</div></div>) :

            (

              <React.Fragment>

                <div className="album py-3 bg-light d-block d-sm-none">
                  <div className="container">
                    <div className="row">
                      <div className="col-12 mb-3">
                        <h2>Destinations les plus proches</h2>
                      </div>

                      <div className="scrolling-wrapper-flexbox">
                        {
                          this.state.proche.map((current) => <Item image={hotel} lieu={current} />)
                        }
                      </div>


                    </div>

                  </div>

                </div>

                <div className="album py-3 bg-light d-none d-sm-block">
                  <div className="container">
                    <div className="row">
                      <div className="col-12 mb-3">
                        <h4>Destinations les plus proches</h4>
                      </div>
                      {
                        this.state.proche.map((current) => <LargeItem image={hotel} lieu={current} />)
                      }
                      <div className="col-12 mb-3 mt-4">
                        <h4>Nos choix</h4>
                      </div>
                      {
                        this.state.choix.map((current) => <LargeItem image={snack} lieu={current} />)
                      }


                    </div>

                  </div>

                </div>
              </React.Fragment>

            )
        }



      </React.Fragment>
    );
  }
}

export default Home;




/*


                      <div className="col-12 mb-3">
                        <h4>Favoris des utilisateurs</h4>
                      </div> {
                        this.state.favorie.map((current) => <LargeItem image={divers} lieu={current} />)
                      }

      <div class="album py-3 bg-light d-block d-sm-none">
        <div class="container">
          <div class="row">
            <div class="col-12 mb-3">
              <h2>Destinations les plus proche</h2>
            </div>
            <div class="scrolling-wrapper-flexbox">
                <div class="col-12">
                  <div class="card mb-4 box-shadow">
                    <img class="card-img-top" src="img/hotel.png" width="100" height="225" alt="Card image cap">
                    <div class="card-body">
                      <p class="card-text">
                        Doté d'une piscine exterieur et offrant une vue sur la ville, Le Mikkael's Hotel est un lieu de choix
                        pour des escapades à Brazzaville.
                      </p>
                      <div class="d-flex justify-content-between align-items-center">
                        <div class="btn-group">
                          <button type="button" class="btn btn-sm btn-outline-secondary">Voir</button>
                          <button type="button" class="btn btn-sm btn-outline-secondary">Appeler</button>
                        </div>
                        <i class="fa fa-maker-alt fa-xs fa-sm fa-lg"></i><small class="text-muted"><i class="fa fa-map-marker-alt fa-xs fa-sm fa-lg"></i> 250 metres</small>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <div class="card mb-4 box-shadow">
                    <img class="card-img-top" src="img/hotel.png" width="100" height="225" alt="Card image cap">
                    <div class="card-body">
                      <p class="card-text">
                        Doté d'une piscine exterieur et offrant une vue sur la ville, Le Mikkael's Hotel est un lieu de choix
                        pour des escapades à Brazzaville.
                      </p>
                      <div class="d-flex justify-content-between align-items-center">
                        <div class="btn-group">
                          <button type="button" class="btn btn-sm btn-outline-secondary">Voir</button>
                          <button type="button" class="btn btn-sm btn-outline-secondary">Appeler</button>
                        </div>
                        <i class="fa fa-maker-alt fa-xs fa-sm fa-lg"></i><small class="text-muted"><i class="fa fa-map-marker-alt fa-xs fa-sm fa-lg"></i> 250 metres</small>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <div class="card mb-4 box-shadow">
                    <img class="card-img-top" src="img/hotel.png" width="100" height="225" alt="Card image cap">
                    <div class="card-body">
                      <p class="card-text">
                        Doté d'une piscine exterieur et offrant une vue sur la ville, Le Mikkael's Hotel est un lieu de choix
                        pour des escapades à Brazzaville.
                      </p>
                      <div class="d-flex justify-content-between align-items-center">
                        <div class="btn-group">
                          <button type="button" class="btn btn-sm btn-outline-secondary">Voir</button>
                          <button type="button" class="btn btn-sm btn-outline-secondary">Appeler</button>
                        </div>
                        <i class="fa fa-maker-alt fa-xs fa-sm fa-lg"></i><small class="text-muted"><i class="fa fa-map-marker-alt fa-xs fa-sm fa-lg"></i> 250 metres</small>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <div class="card mb-4 box-shadow">
                    <img class="card-img-top" src="img/hotel.png" width="100" height="225" alt="Card image cap">
                    <div class="card-body">
                      <p class="card-text">
                        Doté d'une piscine exterieur et offrant une vue sur la ville, Le Mikkael's Hotel est un lieu de choix
                        pour des escapades à Brazzaville.
                      </p>
                      <div class="d-flex justify-content-between align-items-center">
                        <div class="btn-group">
                          <button type="button" class="btn btn-sm btn-outline-secondary">Voir</button>
                          <button type="button" class="btn btn-sm btn-outline-secondary">Appeler</button>
                        </div>
                        <i class="fa fa-maker-alt fa-xs fa-sm fa-lg"></i><small class="text-muted"><i class="fa fa-map-marker-alt fa-xs fa-sm fa-lg"></i> 250 metres</small>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <div class="card mb-4 box-shadow">
                    <img class="card-img-top" src="img/hotel.png" width="100" height="225" alt="Card image cap">
                    <div class="card-body">
                      <p class="card-text">
                        Doté d'une piscine exterieur et offrant une vue sur la ville, Le Mikkael's Hotel est un lieu de choix
                        pour des escapades à Brazzaville.
                      </p>
                      <div class="d-flex justify-content-between align-items-center">
                        <div class="btn-group">
                          <button type="button" class="btn btn-sm btn-outline-secondary">Voir</button>
                          <button type="button" class="btn btn-sm btn-outline-secondary">Appeler</button>
                        </div>
                        <i class="fa fa-maker-alt fa-xs fa-sm fa-lg"></i><small class="text-muted"><i class="fa fa-map-marker-alt fa-xs fa-sm fa-lg"></i> 250 metres</small>
                      </div>
                    </div>
                  </div>
                </div>
            </div>
          </div>
        </div>
      </div>

      <div class="album py-3 bg-light d-none d-sm-block">
        <div class="container">
          <div class="row">
            <div class="col-12 mb-3">
              <h2>Destinations les plus proche</h2>
            </div>
            <div class="col-sm-6 col-md-6 col-lg-4">
              <div class="card mb-4 box-shadow">
                <img class="card-img-top" src="img/hotel.png" width="100" height="225" alt="Card image cap">
                <div class="card-body">
                  <p class="card-text">
                    Doté d'une piscine exterieur et offrant une vue sur la ville, Le Mikkael's Hotel est un lieu de choix
                    pour des escapades à Brazzaville.
                  </p>
                  <div class="d-flex justify-content-between align-items-center">
                    <div class="btn-group">
                      <button type="button" class="btn btn-sm btn-outline-secondary">Voir</button>
                      <button type="button" class="btn btn-sm btn-outline-secondary">Appeler</button>
                    </div>
                    <i class="fa fa-maker-alt fa-xs fa-sm fa-lg"></i><small class="text-muted"><i class="fa fa-map-marker-alt fa-xs fa-sm fa-lg"></i> 250 metres</small>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-6 col-md-6 col-lg-4">
              <div class="card mb-4 box-shadow">
                <img class="card-img-top" src="img/hotel.png" width="100" height="225" alt="Card image cap">
                <div class="card-body">
                  <p class="card-text">
                    Doté d'une piscine exterieur et offrant une vue sur la ville, Le Mikkael's Hotel est un lieu de choix
                    pour des escapades à Brazzaville.
                  </p>
                  <div class="d-flex justify-content-between align-items-center">
                    <div class="btn-group">
                      <button type="button" class="btn btn-sm btn-outline-secondary">Voir</button>
                      <button type="button" class="btn btn-sm btn-outline-secondary">Appeler</button>
                    </div>
                    <i class="fa fa-maker-alt fa-xs fa-sm fa-lg"></i><small class="text-muted"><i class="fa fa-map-marker-alt fa-xs fa-sm fa-lg"></i> 250 metres</small>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-6 col-md-6 col-lg-4">
              <div class="card mb-4 box-shadow">
                <img class="card-img-top" src="img/hotel.png" width="100" height="225" alt="Card image cap">
                <div class="card-body">
                  <p class="card-text">
                    Doté d'une piscine exterieur et offrant une vue sur la ville, Le Mikkael's Hotel est un lieu de choix
                    pour des escapades à Brazzaville.
                  </p>
                  <div class="d-flex justify-content-between align-items-center">
                    <div class="btn-group">
                      <button type="button" class="btn btn-sm btn-outline-secondary">Voir</button>
                      <button type="button" class="btn btn-sm btn-outline-secondary">Appeler</button>
                    </div>
                    <i class="fa fa-maker-alt fa-xs fa-sm fa-lg"></i><small class="text-muted"><i class="fa fa-map-marker-alt fa-xs fa-sm fa-lg"></i> 250 metres</small>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-12 mb-3 mt-4">
              <h2>Nos choix</h2>
            </div>
            <div class="col-sm-6 col-md-6 col-lg-4">
              <div class="card mb-4 box-shadow">
                <img class="card-img-top" src="img/snack.png" width="100" height="225" alt="Card image cap">
                <div class="card-body">
                  <p class="card-text">
                    Doté d'une piscine exterieur et offrant une vue sur la ville, Le Mikkael's Hotel est un lieu de choix
                    pour des escapades à Brazzaville.
                  </p>
                  <div class="d-flex justify-content-between align-items-center">
                    <div class="btn-group">
                      <button type="button" class="btn btn-sm btn-outline-secondary">Voir</button>
                      <button type="button" class="btn btn-sm btn-outline-secondary">Appeler</button>
                    </div>
                    <i class="fa fa-maker-alt fa-xs fa-sm fa-lg"></i><small class="text-muted"><i class="fa fa-map-marker-alt fa-xs fa-sm fa-lg"></i> 250 metres</small>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-6 col-md-6 col-lg-4">
              <div class="card mb-4 box-shadow">
                <img class="card-img-top" src="img/snack.png" width="100" height="225" alt="Card image cap">
                <div class="card-body">
                  <p class="card-text">
                    Doté d'une piscine exterieur et offrant une vue sur la ville, Le Mikkael's Hotel est un lieu de choix
                    pour des escapades à Brazzaville.
                  </p>
                  <div class="d-flex justify-content-between align-items-center">
                    <div class="btn-group">
                      <button type="button" class="btn btn-sm btn-outline-secondary">Voir</button>
                      <button type="button" class="btn btn-sm btn-outline-secondary">Appeler</button>
                    </div>
                    <i class="fa fa-maker-alt fa-xs fa-sm fa-lg"></i><small class="text-muted"><i class="fa fa-map-marker-alt fa-xs fa-sm fa-lg"></i> 250 metres</small>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-6 col-md-6 col-lg-4">
              <div class="card mb-4 box-shadow">
                <img class="card-img-top" src="img/snack.png" width="100" height="225" alt="Card image cap">
                <div class="card-body">
                  <p class="card-text">
                    Doté d'une piscine exterieur et offrant une vue sur la ville, Le Mikkael's Hotel est un lieu de choix
                    pour des escapades à Brazzaville.
                  </p>
                  <div class="d-flex justify-content-between align-items-center">
                    <div class="btn-group">
                      <button type="button" class="btn btn-sm btn-outline-secondary">Voir</button>
                      <button type="button" class="btn btn-sm btn-outline-secondary">Appeler</button>
                    </div>
                    <i class="fa fa-maker-alt fa-xs fa-sm fa-lg"></i><small class="text-muted"><i class="fa fa-map-marker-alt fa-xs fa-sm fa-lg"></i> 250 metres</small>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-12 mb-3">
              <h2>Favoris des utilisateurs</h2>
            </div>
            <div class="col-sm-6 col-md-6 col-lg-4">
              <div class="card mb-4 box-shadow">
                <img class="card-img-top" src="img/divert.png" width="100" height="225" alt="Card image cap">
                <div class="card-body">
                  <p class="card-text">
                    Doté d'une piscine exterieur et offrant une vue sur la ville, Le Mikkael's Hotel est un lieu de choix
                    pour des escapades à Brazzaville.
                  </p>
                  <div class="d-flex justify-content-between align-items-center">
                    <div class="btn-group">
                      <button type="button" class="btn btn-sm btn-outline-secondary">Voir</button>
                      <button type="button" class="btn btn-sm btn-outline-secondary">Appeler</button>
                    </div>
                    <i class="fa fa-maker-alt fa-xs fa-sm fa-lg"></i><small class="text-muted"><i class="fa fa-map-marker-alt fa-xs fa-sm fa-lg"></i> 250 metres</small>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-6 col-md-6 col-lg-4">
              <div class="card mb-4 box-shadow">
                <img class="card-img-top" src="img/divert.png" width="100" height="225" alt="Card image cap">
                <div class="card-body">
                  <p class="card-text">
                    Doté d'une piscine exterieur et offrant une vue sur la ville, Le Mikkael's Hotel est un lieu de choix
                    pour des escapades à Brazzaville.
                  </p>
                  <div class="d-flex justify-content-between align-items-center">
                    <div class="btn-group">
                      <button type="button" class="btn btn-sm btn-outline-secondary">Voir</button>
                      <button type="button" class="btn btn-sm btn-outline-secondary">Appeler</button>
                    </div>
                    <i class="fa fa-maker-alt fa-xs fa-sm fa-lg"></i><small class="text-muted"><i class="fa fa-map-marker-alt fa-xs fa-sm fa-lg"></i> 250 metres</small>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-6 col-md-6 col-lg-4">
              <div class="card mb-4 box-shadow">
                <img class="card-img-top" src="img/divert.png" width="100" height="225" alt="Card image cap">
                <div class="card-body">
                  <p class="card-text">
                    Doté d'une piscine exterieur et offrant une vue sur la ville, Le Mikkael's Hotel est un lieu de choix
                    pour des escapades à Brazzaville.
                  </p>
                  <div class="d-flex justify-content-between align-items-center">
                    <div class="btn-group">
                      <button type="button" class="btn btn-sm btn-outline-secondary">Voir</button>
                      <button type="button" class="btn btn-sm btn-outline-secondary">Appeler</button>
                    </div>
                    <i class="fa fa-maker-alt fa-xs fa-sm fa-lg"></i><small class="text-muted"><i class="fa fa-map-marker-alt fa-xs fa-sm fa-lg"></i> 250 metres</small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

*/